import medicationDSSRelease1 from "./medication-dss-release1";
import medicationDSSRelease2 from "./medication-dss-release2";
import medicationDSSRelease4 from "./medication-dss-release4";

/*
key: key of the question (question key from questionnaire DSSInformation)
defaultValue: the default value of the question
info: Extra tooltip information

display: <condition function>   decides when the question is displayed in start encounter
post: <condition function>  decides when the question needs to be posted to backend,
usually this is just the visit numbers in which the question can be asked

note - questions that need to be posted but are not displayed will be posted as NULL
note2 - display/post are now deferred to dedicated file for specific release, @see bottom file
*/
const medicationDSS = [
  {
    key: 'MYOCARDIAL_INFARCTION_12MONTHS',
    defaultValue: null,
  },
  {
    key: 'STEMI_NSTEMI',
    defaultValue: null,
  },
  {
    key: 'HISTORY_ATRIAL_FIBRILLATION',
    defaultValue: null,
  },
  {
    key: 'SUFFERS_SYSTOLIC_HF_OR_LV_DYSFUNCTION',
    defaultValue: null,
  },
  {
    key: 'PULMONARY_OR_SYSTEMIC_CONGESTION',
    defaultValue: null,
  },
  {
    key: 'EFFORT_ANGINA',
    defaultValue: null,
  },
  {
    key: 'ANGINA_PECTORIS_IN_REST',
    defaultValue: null,
  },
  {
    key: 'IS_SYMPTOMATIC',
    defaultValue: null,
  },
  {
    key: 'HAS_HYPERKALAEMIA',
    defaultValue: null,
  },
  {
    key: 'ANTERIOR_INFARCTION',
    defaultValue: null,
  },
  {
    key: 'RISK_GASTRO_INTESTINAL_BLEEDING',
    defaultValue: null,
  },
  {
    key: 'HISTORY_MI',
    defaultValue: '',
    info: "Indicate if the subject has a history of prior MI. In case “Type of ischemic heart disease during index cardiovascular event” is “Non-ST elevation MI” or “ST elevation MI”, this refers to any MI prior to this event."
  },
  {
    key: 'HAD_PCI',
    defaultValue: null,
  },
  {
    key: 'PCI_DATE',
    defaultValue: '',
  },
  {
    key: 'SECOND_VASCULAR_EVENT_2YEARS_ON_STATIN',
    defaultValue: null,
  },
  {
    key: 'ALREADY_HIGH_DOSE_STATIN',
    defaultValue: null,
  },
  {
    key: 'ACEI_INTOLERANCE',
    defaultValue: null,
  },
  {
    key: 'INTOLERANCE_ASPIRIN',
    defaultValue: null,
  },
  {
    key: 'INTOLERANCE_STATINS',
    defaultValue: null,
  },
  {
    key: 'SYSTOLIC_HEART_FAILURE_OR_KIDNEY_DISEASE_OR_LV_DYSFUNCTION',
    defaultValue: null,
  },
];

const deferDisplayToDSSRelease = deferToDSSRelease('display');
const deferPostToDSSRelease = deferToDSSRelease('post');

// Defer to choice to display/post to release file (medication-dss-release1, medication-dss-release2, etc...)
for (let i=0; i<medicationDSS.length; i++){
  medicationDSS[i].display = deferDisplayToDSSRelease
  medicationDSS[i].post = deferPostToDSSRelease
}

export const getMedicationDSSQuestion = function (key, config = null){
  if (!config){
    config = medicationDSS
  }

  for (let i=0; i<config.length;i++)
    if (config[i].key === key)
      return config[i]
}

function deferToDSSRelease(deferField) {
  return function (runObject) {
    const
        {rootGetters, visit} = runObject,
        question = runObject.config.key,
        encounter = rootGetters['patientSummary/getEncounter'](visit)
    ;

    // Get release that was run for this visit, if encounter didn't exist yet or release was not run yet, get last release
    const targetRelease = encounter && encounter.DSSRelease ? encounter.DSSRelease : rootGetters.getServerInfo("dssRelease");

    let questions;

    switch (targetRelease) {
      case 'release1':
        questions = medicationDSSRelease1;
        break;
      case 'release2':
        questions = medicationDSSRelease2;
        break;
      case 'release3':
        // not a typo, release2/3 use exact same questions
        questions = medicationDSSRelease2;
        break;
      case 'release4':
        questions = medicationDSSRelease4;
        break;
      default:
        throw new Error("Unconfigured questions for release " + targetRelease);
    }

    const questionConfig = getMedicationDSSQuestion(question, questions)

    if (questionConfig?.[deferField]) {
      return questionConfig[deferField](runObject)
    }

    return false
  }
}

export default medicationDSS;
